import { Dispatch, FC, SetStateAction } from 'react'

import { Autoplay, Keyboard, Mousewheel, Navigation, Pagination } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Swiper, SwiperSlide } from 'swiper/react'


interface IProps {
  components: JSX.Element[] | FC<{}>[]
  navigationArrows?: 'on' | 'off'
  paginationBullets?: 'on' | 'off'
  slidesPerView?: number
  autoSlideTime?: number
  padding?: boolean
  color?: 'wight' | 'dark' | 'blue'
  autoplay?: any
  spaceBetween?: number
  breakpoints?: any
  getActiveSlide?: Dispatch<SetStateAction<number>>
}
const SwiperSliderComponent: FC<IProps> = ({
  components,
  navigationArrows,
  paginationBullets,
  slidesPerView,
  breakpoints,
  autoSlideTime,
  padding,
  color,
  autoplay=false,
  spaceBetween = 30,
  getActiveSlide
}) => {
  return (
    <Swiper
      onSlideChange={(swiperCore) => getActiveSlide ? getActiveSlide(swiperCore.activeIndex) : null}
      cssMode={true}
      mousewheel={true}
      navigation={navigationArrows === 'on' ? true : false}
      pagination={paginationBullets === 'on' ? { clickable: true,  dynamicBullets:true} : false}
      autoplay={
        autoplay === true
          ? {
              delay: autoSlideTime ? autoSlideTime : 5000,
              disableOnInteraction: false,
            }
          : false
      }
      keyboard={true}
      modules={[Navigation, Pagination, Mousewheel, Keyboard, Autoplay]}
      className={`swiper-custom ${padding ? 'padding' : ''} ${color ? color : 'blue'}`}
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      breakpoints={breakpoints}
    >
      {components && components?.length && components.map((component, index) => {
        return <SwiperSlide key={index}>{component}</SwiperSlide>
      })}
    </Swiper>
  )
}

export default SwiperSliderComponent